export const BRAND_NAME = {
  verifoneCentral: 'Verifone Central',
  appMarketPlace: 'App Marketplace',
};
